(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-blubom"] && !Shopify.designMode) return;
  try {
    /*
    Visibility of the order fields is pure CSS (:has), so the form works without JS.
    This element keeps hidden controls out of the submitted data (otherwise the email
    would carry an empty or duplicated "Zamówienie" line), makes the order number required
    only while it is shown, and adds the admin lookup link for guests.
  */
  if (!customElements.get('blubom-contact-form')) {
    customElements.define(
      'blubom-contact-form',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.sync);
          // Capture phase: runs before any listener on the form itself (e.g. hCaptcha)
          this.addEventListener('submit', this.fillCustomerLookup, true);
          this.sync();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.sync);
          this.removeEventListener('submit', this.fillCustomerLookup, true);
        }

        sync = () => {
          this.fillCustomerLookup();

          const toggle = this.querySelector('.blubom-contact__order-toggle input[type="checkbox"]');
          if (!toggle) return;

          const select = this.querySelector('[data-order-select]');
          const text = this.querySelector('[data-order-text]');
          const enabled = toggle.checked;
          const wantsOther = !select || select.value === '__other';
          // Field name is taken from the markup once, so it lives in one place only
          if (select && !select.dataset.fieldName) select.dataset.fieldName = select.getAttribute('name');

          if (select) {
            select.disabled = !enabled;
            // Keep the select interactive, but don't send the "__other" marker
            if (enabled && !wantsOther) {
              select.setAttribute('name', select.dataset.fieldName);
            } else {
              select.removeAttribute('name');
            }
          }

          if (text) {
            const active = enabled && wantsOther;
            text.disabled = !active;
            text.required = active;
            text.setAttribute('aria-required', String(active));
          }
        };

        // Guests: admin search link by the email they typed. Refreshed on every change
        // and once more at submit, so autofill and last-second edits are covered.
        fillCustomerLookup = () => {
          const lookup = this.querySelector('[data-customer-lookup]');
          if (!lookup) return;

          const email = this.querySelector('input[type="email"]')?.value.trim();
          lookup.disabled = !email;
          lookup.value = email ? lookup.dataset.adminBase + encodeURIComponent(email) : '';
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
